import { SDQueryTimeRange, SDQueryEventState } from "../../../contracts";
export function isValidEventState(eventState) {
    return Object.values(SDQueryEventState).indexOf(eventState) > -1;
}
export function isValidDateRange_from(from) {
    const d = new Date(from);
    return d instanceof Date && !isNaN(d);
}
export function isValidDateRange_timeRange(timeRange) {
    return Object.values(SDQueryTimeRange).indexOf(timeRange) > -1;
}
//# sourceMappingURL=index.js.map